import { makeStyles } from '@material-ui/core';

/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
const styles = makeStyles(theme => ({
    infoMainContainer: {
        maxWidth: '995px',
        margin: 'auto',
    },
    InfoContainer: props => ({
        boxShadow: theme?.palette?.boxShadow,
        marginTop: '3rem',
        borderRadius: '0.375rem',
        [theme.breakpoints.down('sm')]: {
            background: `url(${props?.infoTileMobile}) no-repeat center/cover`,
            backgroundColor: theme.palette.backgroundColor,
        },
        [theme.breakpoints.up('sm')]: {
            background: `url(${props?.infoTileTablet}) right/cover no-repeat`,
            backgroundColor: theme.palette.backgroundColor,
        },
        [theme.breakpoints.up('md')]: {
            background: `url(${props?.infoTileDesktop}) 100% 100%/cover no-repeat `,
            backgroundColor: theme.palette.backgroundColor,
            justifyContent: 'space-around',
        },
    }),
    InfoDetails: {
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            alignItems: 'center',
        },
    },
    InfoBox: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            textAlign: 'center',
            padding: '1.938rem 1rem 1.938rem 1rem',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            padding: 0,
        },
    },
    infoText: {
        padding: '3.875rem 0 0 3.5rem',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        [theme.breakpoints.down('xs')]: {
            padding: 0,
            textAlign: 'center',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            padding: 0,
        },
    },
    infoTextAlign: {
        textAlign: 'center',
        paddingTop: '1rem',
        [theme.breakpoints.down('xs')]: {
            paddingTop: '1.5rem',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            padding: 0,
        },
    },
    InfoTitle: {
        color: theme?.palette?.textHeading,
        letterSpacing: 'inherit',
        [theme.breakpoints.down('sm')]: {
            padding: '1rem 2rem 0 2rem',
        },
        [theme.breakpoints.down('xs')]: {
            padding: 0,
        },
    },
    InfoDescription: {
        paddingTop: '1rem',
        color: theme?.palette?.textBody,
        letterSpacing: 'inherit',
        [theme.breakpoints.between('sm', 'md')]: {
            padding: '1rem 2rem 0 2rem',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '1rem 0 0 0',
        },
    },
    InfoCTA: {
        padding: '1.5rem 0 1.625rem 0',
        [theme.breakpoints.down('xs')]: {
            padding: '2rem 0 0 0',
            width: '100%',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            padding: '1.5rem',
        },
    },
    infoTileIcon: {
        width: '4.5rem',
        height: '4.5rem',
    },
    InfoCenterAlign: {
        marginTop: '3rem',
        borderRadius: '0.375rem',
        boxShadow: theme?.palette?.boxShadow,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: theme?.palette?.backgroundColor,
    },
    InfoBoxCenter: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        paddingTop: '1.625rem',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            padding: '2rem 1rem 1.938rem 1rem',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            textAlign: 'center',
            paddingBottom: '1rem',
        },
    },
    ForegroundImageContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 0,
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center',
            alignItems: 'flex-start',
            paddingBottom: '3.44rem',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            justifyContent: 'center',
        },
    },
    ForegroundImage: props => ({
        width: '10.106rem',
        height: '10.106rem',
        [theme.breakpoints.up('md')]: {
            background: `url(${props?.infoTileForegroundDesktop}) 100% 100%/cover no-repeat`,
        },
        [theme.breakpoints.down('sm')]: {
            background: `url(${props?.infoTileForegroundMobile}) no-repeat center/cover `,
            width: '6rem',
            height: '6rem',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            background: `url(${props?.infoTileForegroundTablet}) right/cover no-repeat`,
        },
    }),
}));

export default styles;
